import type { ReactElement } from 'react';

import { cn } from '@/lib/utils';

interface SidebarCountBadgeProps {
  count: number | string;
  colour?: 'red' | 'green';
}

export default function SidebarCountBadge({
  count,
  colour = 'red',
}: SidebarCountBadgeProps): ReactElement {
  return (
    <span
      className={cn(
        'vtwo:flex vtwo:h-[15px] vtwo:min-w-[15px] vtwo:shrink-0 vtwo:items-center vtwo:justify-center vtwo:rounded-full vtwo:px-1 vtwo:text-[10px] vtwo:font-medium vtwo:leading-none vtwo:text-white',
        colour === 'green' ? 'vtwo:bg-[#2f9d6d]' : 'vtwo:bg-[#cb2e2e]'
      )}
    >
      {count}
    </span>
  );
}
